module.exports = __webpack_public_path__ + "static/media/my_contracts_banner_mobile.a8a9fe84.png";